export default "assets/images/quotes-99eb9bf6.svg";